import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";
import {
  IDataPreference,
  IFilterIndicadores
} from "@/features/financas/views/Indicadores/@types/type";
import SaveVendasPanelToApi from "../../../VendasPanel/preferencias/SaveVendasPanelToApi";
import { injectable } from "inversify";
import "reflect-metadata";
import SaveFluxoDeCaixaToApi from "../../../FluxoCaixaPanel/preferencias/SaveFluxoDeCaixaToApi";
import SaveDREToApi from "../../../DREPanel/preferencias/SaveDREToApi";
import SaveFiltrosGeraisToApi from "../../SaveFiltrosGeraisToApi";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// todo: refatorar esse mapper para não utilizar ANY (Vesentini)
const IWidgetsNamesMapper: Partial<Record<number, any>> = {
  [EWidgets.Preferencias]: SaveFiltrosGeraisToApi,
  [EWidgets.VendasPanel]: SaveVendasPanelToApi,
  [EWidgets.FluxoCaixaPainel]: SaveFluxoDeCaixaToApi,
  [EWidgets.DREPanel]: SaveDREToApi
};

@injectable()
export default class CreatePreferencias {
  private preferencias: IDataPreference[] = [];

  buildPreferencias(filtros: IFilterIndicadores[]) {
    for (const filtro of filtros) {
      const classConstructor = IWidgetsNamesMapper[filtro.id];

      if (classConstructor) {
        const newInstance = new classConstructor();
        const newFilters = newInstance.buildPreference(filtro);

        if (Array.isArray(newFilters)) {
          this.preferencias.push(...(newFilters as IDataPreference[]));
        } else if (newFilters) {
          this.preferencias.push(newFilters);
        }
      }
    }

    return this.preferencias;
  }
}
